import { useState } from 'react';

export type UseTimeKeepingFiltersReturn = {
  selectedLogos: string[];
  selectedPeople: string[];
  sessionSupports: string[];
  setSelectedLogos: (logos: string[]) => void;
  setSelectedPeople: (people: string[]) => void;
  setSessionSupports: (supports: string[]) => void;
};

export function useTimeKeepingFilters(): UseTimeKeepingFiltersReturn {
  const [selectedLogos, setSelectedLogos] = useState<string[]>([]);
  const [selectedPeople, setSelectedPeople] = useState<string[]>([]);
  const [sessionSupports, setSessionSupports] = useState<string[]>([]);

  return {
    selectedLogos,
    selectedPeople,
    sessionSupports,
    setSelectedLogos,
    setSelectedPeople,
    setSessionSupports,
  };
}
